import { render, staticRenderFns } from "./TargetGenConfig.vue?vue&type=template&id=5948e691&scoped=true&"
import script from "./TargetGenConfig.vue?vue&type=script&lang=js&"
export * from "./TargetGenConfig.vue?vue&type=script&lang=js&"
import style0 from "./TargetGenConfig.vue?vue&type=style&index=0&id=5948e691&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5948e691",
  null
  
)

export default component.exports